const config: siteConfig = {
  // Softdigi endpoint
  REACT_APP_API_URL: "https://efl.tthefl.com/api",
  DIGI_SERVER_URL: "https://sds.softdigisolutions.com/",
//  REACT_APP_API_URL: "http://192.168.1.37/softdigisolutions/sds_efl_backend/api",
};

export default config;
